import React, { useEffect, useState } from 'react'
import WelcomeScreenanimation from '../Assets/animations/welcomscreenrotation.json';
import axios from 'axios';
import Lottie from 'lottie-react';
import { IconButton, Box, CircularProgress, Autocomplete, TextField, Chip, Button, Checkbox, Dialog, DialogTitle, DialogContent } from '@mui/material';
import WellnessStore from '../DataRepo/WellnessStore';
import VikritiStore from '../DataRepo/VikiritiStore';
import vikritinext from '../Assets/images/vikritinext.png'
import infoIconImg from '../Assets/images/Group 16493.png'
import { useNavigate } from 'react-router-dom';
import { ChevronLeft, ArrowBack, InfoOutlined, Close } from '@mui/icons-material';
import { profileModel } from '../Axios/AxiosConfig';
import { getUserDetails } from '../Auth/AuthUtil';

function Symptoms() {

    const { Vikriti_data, isVikriti_dataloading, getVikritidata } = VikritiStore();

    const userDetails = getUserDetails()

    const [inputValue, setInputValue] = useState('');

    const { Selected_Wellness, getSelected_Wellness } = WellnessStore();

    const [dialogstate, setOpendialog] = useState(false)

    const [selectedSymptoms, setSelectedSymptoms] = useState([]);

    const navigate = useNavigate()

    const [currentLevel, setCurrentLevel] = useState(1);

    const [selectedCustomSymptoms, setSelectedCustomSymptoms] = useState([]);

    const [currentSubCategoryIndex, setCurrentSubCategoryIndex] = useState(0);

    const [selectedSubCategories, setSelectedSubCategories] = useState([]);

    const [currentSubCategoryToDisplay, setCurrentSubCategoryToDisplay] = useState(0);

    const [showSelectedWellness, setShowSelectedWellness] = useState(false)

    const [selectedMainSymptoms, setMainSelectedSymptoms] = useState([]);

    const filteredVikritiData = Vikriti_data?.filter(item => item?.sub_category?.toLowerCase() !== 'na');

    const categories = filteredVikritiData?.filter((s) => Selected_Wellness?.filter((i) => i?.selected).some((e) => s?.category === e?.name));

    const groupedCategories = categories.reduce((acc, symptom) => {
        const { sub_category } = symptom;
        if (!acc[sub_category]) {
            acc[sub_category] = [];
        }
        acc[sub_category].push(symptom);
        return acc;
    }, {});

    const groupedFilteredVikritiData = filteredVikritiData
        ?.filter((s) => selectedSymptoms?.some((e) => e?.sub_category === s?.sub_category))
        ?.reduce((acc, symptom) => {
            const { sub_category } = symptom;
            if (!acc[sub_category]) {
                acc[sub_category] = [];
            }
            acc[sub_category]?.push(symptom);
            return acc;
        }, {});

    const groupedBySubCategory = showSelectedWellness
        ? groupedCategories
        : groupedFilteredVikritiData;

    const filteredSubCategoriesForCategories = Object?.keys(groupedCategories);

    const filteredSubCategoriesForFilteredVikritiData = Object?.keys(groupedFilteredVikritiData);

    const filteredSubCategories = showSelectedWellness
        ? filteredSubCategoriesForCategories
        : filteredSubCategoriesForFilteredVikritiData;

    const currentSubCategory = filteredSubCategories[currentSubCategoryIndex] || filteredSubCategories[0];

    function calculateDoshaValues(vikritiResponse) {
        let v = 0;
        let p = 0;
        let k = 0;

        const uniqueCategories = new Set();

        vikritiResponse.forEach(vikriti => {
            vikriti.dosha_increase.split(",").forEach(dosha => {
                switch (dosha.trim().toLowerCase()) {
                    case 'v':
                        v++;
                        break;
                    case 'p':
                        p++;
                        break;
                    case 'k':
                        k++;
                        break;
                }
            });

            vikriti.dosha_decrease.split(",").forEach(dosha => {
                switch (dosha.trim().toLowerCase()) {
                    case 'v':
                        v--;
                        break;
                    case 'p':
                        p--;
                        break;
                    case 'k':
                        k--;
                        break;
                }
            });

            uniqueCategories.add(vikriti.category);
        });


        const totalDoshas = vikritiResponse.length;


        const vPercent = (v / totalDoshas) * 100;
        const pPercent = (p / totalDoshas) * 100;
        const kPercent = (k / totalDoshas) * 100;

        return { vataAssScore: v, pittaAssScore: p, kaphaAssScore: k }
    }

    let ExploreApp = localStorage.getItem('ExploreApp')

    ExploreApp = JSON.parse(ExploreApp) || { selected: false }

    const UpdateSelectedSymptoms = async () => {
        try {
            const scores = calculateDoshaValues(selectedMainSymptoms);

            let res = await profileModel.post('/UpdateVikriti', {
                UID: userDetails?.UID,
                count: [...selectedSymptoms, ...selectedCustomSymptoms]?.length || 0,
                date: Date.now().toString(),
                vataAssScore: scores?.vataAssScore || 0,
                pittaAssScore: scores?.pittaAssScore || 0,
                kaphaAssScore: scores?.kaphaAssScore || 0,
                vikritiList: [...selectedSymptoms, ...selectedCustomSymptoms] || [],
                vataPulseScore: 0,
                pittaPulseScore: 0,
                kaphaPulseScore: 0,
            })

            if (res.status === 200) {
                setSelectedSymptoms([]);
                setSelectedCustomSymptoms([]);
                setMainSelectedSymptoms([]);
                setInputValue('');

                if (ExploreApp?.selected) {
                    localStorage.removeItem('ExploreApp')
                    navigate("/");
                }

                else {
                    navigate("/doctorProfiles");
                }
            }

        } catch (err) {
            console.log("UpdateSelectedSymptoms Error:", err);
        }
    };

    const getUniqueSymptoms = () => {
        const symptomsSet = new Set();
        filteredVikritiData?.forEach(item => {
            item?.symptoms?.split(',')?.forEach(symptom => {
                symptomsSet?.add(symptom?.trim()?.toLowerCase());
            });
        });
        return Array.from(symptomsSet);
    };

    const uniqueSymptoms = getUniqueSymptoms();

    const handleAutocompleteChange = (event, value) => {
        if (value != null) {
            const symptomValue = value?.trim();
            const existingSymptom = filteredVikritiData?.find(item => item.symptoms.toLowerCase() === symptomValue.toLowerCase());

            if (symptomValue && !selectedSymptoms?.some((item) => item.symptoms === symptomValue) && !selectedCustomSymptoms.some((item) => item.symptoms === symptomValue)) {
                let newSymptomObj;

                if (existingSymptom) {
                    newSymptomObj = {
                        ...existingSymptom,
                        sub_category: existingSymptom.sub_category || 'na',
                        category: existingSymptom.category || 'na',
                        dhatu_increase: existingSymptom.dhatu_increase || 'na',
                        dhatu_decrease: existingSymptom.dhatu_decrease || 'na',
                        dosha_increase: existingSymptom.dosha_increase || 'na',
                        dosha_decrease: existingSymptom.dosha_decrease || 'na',
                        mala_increase: existingSymptom.mala_increase || 'na',
                        mala_decrease: existingSymptom.mala_decrease || 'na'
                    };
                    setSelectedSymptoms([...selectedSymptoms, newSymptomObj]);
                    setMainSelectedSymptoms([...selectedMainSymptoms, newSymptomObj]);
                } else {
                    newSymptomObj = {
                        dosha_decrease: "na",
                        symptoms: symptomValue,
                        sub_category: "na",
                        category: "na",
                        dhatu_increase: "na",
                        dosha_increase: "na",
                        id: Math.random().toString(36).substr(2, 9),
                        mala_increase: "na",
                        mala_decrease: "na",
                        dhatu_decrease: "na"
                    };

                    setSelectedCustomSymptoms([...selectedCustomSymptoms, newSymptomObj]);
                    setMainSelectedSymptoms([...selectedMainSymptoms, newSymptomObj]);
                }

                setInputValue('');
            }
        }
    };

    const handleItemClick = (symptomObj) => {
        if (!selectedSymptoms.some((item) => item.symptoms === symptomObj.symptoms)) {
            setSelectedSymptoms([...selectedSymptoms, symptomObj]);
            setMainSelectedSymptoms([...selectedMainSymptoms, symptomObj]);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            const symptomValue = event.target.value.trim();
            const existingSymptom = filteredVikritiData?.find(item => item.symptoms.toLowerCase() === symptomValue.toLowerCase());

            if (symptomValue && !selectedSymptoms.some((item) => item.symptoms === symptomValue) && !selectedCustomSymptoms.some((item) => item.symptoms === symptomValue)) {

                let newSymptomObj;

                if (existingSymptom) {
                    newSymptomObj = {
                        ...existingSymptom,
                        sub_category: existingSymptom.sub_category || 'na',
                        category: existingSymptom.category || 'na',
                        dhatu_increase: existingSymptom.dhatu_increase || 'na',
                        dhatu_decrease: existingSymptom.dhatu_decrease || 'na',
                        dosha_increase: existingSymptom.dosha_increase || 'na',
                        dosha_decrease: existingSymptom.dosha_decrease || 'na',
                        mala_increase: existingSymptom.mala_increase || 'na',
                        mala_decrease: existingSymptom.mala_decrease || 'na'
                    };
                    setSelectedSymptoms([...selectedSymptoms, newSymptomObj]);
                    setMainSelectedSymptoms([...selectedMainSymptoms, newSymptomObj]);
                }

                else {
                    newSymptomObj = {
                        dosha_decrease: "na",
                        symptoms: symptomValue,
                        sub_category: "na",
                        category: "na",
                        dhatu_increase: "na",
                        dosha_increase: "na",
                        id: Math.random().toString(36).substr(2, 9),
                        mala_increase: "na",
                        mala_decrease: "na",
                        dhatu_decrease: "na"
                    };
                    setSelectedCustomSymptoms([...selectedCustomSymptoms, newSymptomObj]);
                    setMainSelectedSymptoms([...selectedMainSymptoms, newSymptomObj]);
                }

                setInputValue('');
            }
        }
    };

    const handleDelete = (symptomToDelete) => {
        setSelectedSymptoms(selectedSymptoms?.filter((symptom) => symptom?.symptoms !== symptomToDelete?.symptoms));
        setSelectedCustomSymptoms(selectedCustomSymptoms?.filter((symptom) => symptom?.symptoms !== symptomToDelete?.symptoms));
    };


    useEffect(() => {
        getVikritidata()
    }, [])

    return <div className='Symptoms-page-section'>
        <div className='' >
            <div className="flex items-center justify-between w-full">
                <div style={{ visibility: "hidden", style: { width: "3rem", height: "3rem" } }}>
                    Skip
                </div>
                <div className="Welcome-section-animation flex justify-center items-center">
                    <Lottie animationData={WelcomeScreenanimation} />
                </div>

                <div
                    className="skip-btn flex justify-end"
                    style={{ justifySelf: "flex-end" }}
                    onClick={() => {
                        if (ExploreApp?.selected) {
                            localStorage.removeItem('ExploreApp')
                            navigate("/");
                        }

                        else {
                            navigate("/doctorProfiles");
                        }

                    }}
                >
                    <p>{"Skip"}</p>
                </div>
            </div>
            
            <div style={{ alignSelf: "center", textAlign: "center" }} className='Symptoms-page-section-title'>
                <p>What symptoms or health concerns <br /> are you experiencing? </p>
            </div>

            <div className='mt-3'>
                <Autocomplete
                    freeSolo
                    options={uniqueSymptoms
                        ?.filter(symptom =>
                            !selectedSymptoms?.find(selected =>
                                selected?.symptoms?.toLowerCase() === symptom
                            )
                        )
                        ?.filter(symptom =>
                            symptom?.toLowerCase()?.includes(inputValue?.toLowerCase())
                        )?.map((e) => e?.charAt(0).toUpperCase() + e?.slice(1))
                    }

                    value={inputValue}
                    inputValue={inputValue}
                    onInputChange={(event, newInputValue) => setInputValue(newInputValue)}
                    onChange={handleAutocompleteChange}
                    renderInput={(params) => (
                        <TextField
                            {...params}
                            variant="outlined"
                            value={inputValue}
                            placeholder="Enter your Symptoms"
                            onChange={(e) => setInputValue(e.target.value)}
                            onKeyDown={handleKeyDown}
                            sx={{
                                '& .MuiOutlinedInput-root': {
                                    '&.Mui-focused fieldset': {
                                        borderColor: '#DA6E0B',
                                    },
                                },
                            }}
                        />
                    )}
                />

                {(selectedSymptoms?.length > 0 || selectedCustomSymptoms?.length > 0) && (
                    <div className='selected-symptoms' style={{ marginTop: '20px' }}>

                        {[...selectedSymptoms, ...selectedCustomSymptoms]?.map((symptomObj, index) => (
                            <Chip
                                key={index}
                                label={symptomObj.symptoms}
                                onDelete={() => handleDelete(symptomObj)}
                                style={{ margin: '5px' }}
                            />
                        ))}
                    </div>
                )}
            </div>

            {(selectedSymptoms?.length > 0 || selectedCustomSymptoms?.length > 0) &&
                <div className='mt-5' onClick={() => {
                    UpdateSelectedSymptoms()
                }} style={{ alignSelf: "center", justifySelf: "flex-end", marginTop: "auto", width: "3rem", cursor: "pointer" }} >
                    <img src={vikritinext}></img>
                </div>}

        </div>


    </div>
}

export default Symptoms